
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { gql, useQuery } from '@apollo/client';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import React from 'react';
import Seo from '~/components/util/seo';

const resourceTypesQ = gql`
  query resourceTypes {
    resourceTypes
  }
`;

export { resourceTypesQ };

export default function () {
  const { data } = useQuery(resourceTypesQ);
  const { t } = useTranslation('categories');

  return (
    <>
      <h1 className="text-3xl text-center mt-12">Categories</h1>
      <div
        className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 max-w-6xl mx-4 sm:mx-auto gap-4 my-12
    ">
        {data?.resourceTypes?.map((type) => (
          <Link key={type} href={`/category/${type}`}>
            <a className="p-8 rounded uppercase text-xl font-semibold shadow-md" style={{ backgroundColor: stringToColor(type) }}>
              {t(type, { count: 2 })}
            </a>
          </Link>
        ))}
        <Link href="/category/map">
          <a className="p-8 rounded uppercase text-xl font-semibold shadow-md" style={{ backgroundColor: stringToColor('map') }}>
            {t('map', { count: 2 })}
          </a>
        </Link>
      </div>
      <Seo title="Categories" description="Look for resources of any type" />
    </>
  );
}

function stringToColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  return color;
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/categories',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  